//import * as d3 from 'd3';
function ClientName(prop) {
    return [<h2>Full Name: {prop.firstName} {prop.lastName}</h2>];
}

export {ClientName};